import React from 'react';
import { 
    SwitchBlock, 
    TextFieldBlock,
    TimePickerBlock,
    SelectBlock, 
    MultiSelectBlock, 
    FileUploadBlock 
} from './Blocks';

export const SettingsRenderer = ({
    setting,
    onValueChange,
    logoPreview,
    onLogoUpload,
    controlSize = 'small',
    fullWidth = false,
}) => {
    const controlProps = { controlSize, fullWidth };

    switch (setting.type) {
        case "switch":
            return <SwitchBlock setting={setting} onValueChange={onValueChange} />;
        
        case "time":
            return <TimePickerBlock setting={setting} onValueChange={onValueChange} {...controlProps} />;

        case "text":
        case "number":
        case "textarea":
            return <TextFieldBlock setting={setting} onValueChange={onValueChange} {...controlProps} />;
        
        case "select":
        case "dropdown":
            return <SelectBlock setting={setting} onValueChange={onValueChange} {...controlProps} />;
        
        case "multi-select":
            return <MultiSelectBlock setting={setting} onValueChange={onValueChange} {...controlProps} />;
        
        case "file-upload":
        case "logo-upload":
            return (
                <FileUploadBlock 
                    setting={setting} 
                    onValueChange={onValueChange}
                    logoPreview={logoPreview}
                    onLogoUpload={onLogoUpload}
                />
            );
        
        default:
            return <TextFieldBlock setting={setting} onValueChange={onValueChange} {...controlProps} />;
    }
};
